import { render, staticRenderFns } from "./ValidationArticleData.vue?vue&type=template&id=1e891454"
import script from "./ValidationArticleData.vue?vue&type=script&lang=js"
export * from "./ValidationArticleData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports